export default {
  Anemo: require('../assets/elements/Element_Anemo.png'),
  Cryo: require('../assets/elements/Element_Cryo.png'),
  Dendro: require('../assets/elements/Element_Dendro.png'),
  Electro: require('../assets/elements/Element_Electro.png'),
  Geo: require('../assets/elements/Element_Geo.png'),
  Hydro: require('../assets/elements/Element_Hydro.png'),
  Pyro: require('../assets/elements/Element_Pyro.png')
};